module.exports = __webpack_public_path__ + "img/Mask group@2x(1).4fe32bb1.png";